/**
 * Form Field Class
 */
class FormField {
  /**
   * Create new form field
   * @param {HTMLElement} field Form field
   */
  constructor (field) {
    this.field = field

    // Find <input>, <select>, or <textarea>
    this.input =
      field.querySelector('input') ||
      field.querySelector('select') ||
      field.querySelector('textarea')

    if (this.input.tagName === 'SELECT') {
      this.input.addEventListener('change', () => this.handleInput())
    } else {
      this.input.addEventListener('input', () => this.handleInput())
      this.input.addEventListener('focus', () => this.handleFocus())
      this.input.addEventListener('blur', () => this.handleBlur())
    }

    if (this.input.value) {
      this.field.classList.add('has-value')
    }
  }

  /**
   * Handle focus event
   */
  handleFocus () {
    this.field.classList.add('has-focus')
  }

  /**
   * Handle blur event
   */
  handleBlur () {
    this.field.classList.remove('has-focus')
  }

  /**
   * Handle input event
   */
  handleInput () {
    if (this.input.value) {
      this.field.classList.add('has-value')
    } else {
      this.field.classList.remove('has-value')
    }
  }
}

export default FormField
